<div *ngIf="dataLoading$ | async; else content" style="text-align: center">
  <i class="k-icon k-i-loading" aria-hidden="true"></i>
  <p>{{ 'components.copysachverhalte.copy_facts' | translate }}</p>
</div>

<ng-template #content>
  <div>
    <p>{{ 'components.copysachverhalte.description' | translate }}</p>

    <div class="form-group">
      <div class="uba-control-group">
        <label for="copy-sachverhalte-description"> {{ 'components.copysachverhalte.target' | translate }}* </label>
        <div>
          <textarea
            autoFocus
            id="copy-sachverhalte-description"
            class="form-control"
            [formControl]="targetIdsFormControl"
            placeholder="{{ 'components.copysachverhalte.target_description' | translate }}"
          ></textarea>
        </div>
      </div>
    </div>

    <p *ngIf="isContainingOwnObjectId$ | async" class="validation-error">
      {{ 'components.copysachverhalte.validationerror' | translate }}
    </p>

    <div class="form-group">
      <div class="uba-control-group">
        <label for="copy-sachverhalte-facts"> {{ 'components.copysachverhalte.facts' | translate }}* </label>
        <div>
          <textarea
            id="copy-sachverhalte-facts"
            class="form-control"
            disabled="disabled"
            [value]="copySachverhalteIdsText$ | async"
            placeholder="{{ 'components.copysachverhalte.facts_description' | translate }}"
          ></textarea>
        </div>
      </div>
    </div>

    <p class="success" *ngIf="(successfulIds$ | async).length > 0">
      {{ 'components.copysachverhalte.success_ids' | translate }} {{ (successfulIds$ | async).join(', ') }}
    </p>
    <p class="error" *ngIf="(errorIds$ | async).length > 0">
      {{ 'components.copysachverhalte.error_ids' | translate }} {{ (errorIds$ | async).join(', ') }}
    </p>

    <div class="uba-button-group">
      <button 
        class="btn btn-default"
        (click)="cancel()">
        {{ 'action.cancel' | translate }}
      </button>
      <button 
        class="btn btn-primary" 
        (click)="copy()" 
        [disabled]="!(isValid$ | async)">
        <i class="far fa-paper-plane" aria-hidden="true"></i> 
        {{ 'components.copysachverhalte.copy' | translate }}
      </button>
    </div>
  </div>
</ng-template>
